import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { PublicCargoEvidencesService } from '../public-cargo-evidences/public-cargo-evidences.service';
import { DynamicFirebase } from 'src/app/core/classes/dynamic-firebase';
import { StorageEndpoints } from 'src/app/core/resources/storage-endpoints';
import { Fmt } from 'src/app/core/messages/fmt';
import { Cargo } from 'src/app/core/interfaces/cargo';

type FulfillmentClientsState = 'loading' | 'missing-params' | 'not-found' | 'no-pdf' | 'storage-error' | 'success';

const ERROR_MESSAGES: { [key in Exclude<FulfillmentClientsState, 'loading' | 'success'>]: string } = {
  'missing-params': 'El consecutivo o la empresa no fueron especificados en la URL.',
  'not-found': 'El servicio digitado no existe. Inténtelo de nuevo.',
  'no-pdf': 'Aún no se ha aprobado el documento de esta carga.',
  'storage-error': 'Ha ocurrido un error procesando la solicitud. Inténtelo de nuevo.'
};

@Component({
  selector: 'app-public-fulfillment-clients',
  templateUrl: './public-fulfillment-clients.component.html',
  styleUrls: ['./public-fulfillment-clients.component.scss']
})
export class PublicFulfillmentClientsComponent implements OnInit {
  state: FulfillmentClientsState = 'loading';
  consecutive: string;
  pdfUrl: SafeResourceUrl;

  constructor(
    private route: ActivatedRoute,
    private publicCargoEvidencesService: PublicCargoEvidencesService,
    private spinner: NgxSpinnerService,
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    const { consecutive, companyId } = this.route.snapshot.queryParams;
    if (!consecutive || !companyId) {
      this.state = 'missing-params';
      return;
    }
    this.consecutive = consecutive;
    this.spinner.show();
    this.publicCargoEvidencesService.detailCargoByConsecutive(consecutive, companyId).subscribe(
      (cargo) => this.loadApprovedPdf(cargo, companyId),
      () => {
        this.state = 'not-found';
        this.spinner.hide();
      }
    );
  }

  private async loadApprovedPdf(cargo: Cargo, companyId: string) {
    if (!cargo || !cargo.id) {
      this.state = 'not-found';
      this.spinner.hide();
      return;
    }
    if (!cargo.hasFulfilledApprovedPdf) {
      this.state = 'no-pdf';
      this.spinner.hide();
      return;
    }
    try {
      const configLoaded = await DynamicFirebase.configFirebaseByCompanyId(companyId);
      if (!configLoaded) {
        this.state = 'storage-error';
        this.spinner.hide();
        return;
      }
      const path = `${Fmt.string(StorageEndpoints.cargoFulfillment, cargo.id)}/approved`;
      const storage = DynamicFirebase.getStorageByCompanyId(companyId);
      const result = await storage.ref(path).listAll();
      const pdfItem = result.items.find((item) => item.name.toLowerCase().endsWith('.pdf'));
      if (!pdfItem) {
        this.state = 'no-pdf';
        this.spinner.hide();
        return;
      }
      const url = await pdfItem.getDownloadURL();
      this.pdfUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
      this.state = 'success';
    } catch (error) {
      this.state = 'storage-error';
    } finally {
      this.spinner.hide();
    }
  }

  get errorMessage(): string {
    return ERROR_MESSAGES[this.state] || ERROR_MESSAGES['storage-error'];
  }
}
